import { PRICE_WS_RECONNECT_INTERVAL_MS } from '@helpers';

export enum WebSocketStatus {
  UNINSTANTIATED = -1,
  CONNECTING = 0,
  OPEN = 1,
  CLOSING = 2,
  CLOSED = 3,
}

export interface BaseWsOptions {
  onOpen?: (event: WebSocketEventMap['open']) => void;
  onClose?: (event: WebSocketEventMap['close']) => void;
  onMessage?: (event: WebSocketEventMap['message']) => void;
  onError?: (event: WebSocketEventMap['error']) => void;
  onReconnectStop?: (numAttempts: number) => void;
  shouldReconnect?: (event: WebSocketEventMap['close']) => boolean;
  reconnectInterval?: number | ((lastAttemptNumber: number) => number);
  reconnectAttempts?: number;
  retryOnError?: boolean;
}

export interface BaseWsInstance {
  sendMessage: (message: string) => void;
  lastMessage: WebSocketEventMap['message'] | null;
  getWebSocket: () => WebSocket | null;
  status: WebSocketStatus;
  isConnected: boolean;
  connect: () => void;
  disconnect: (code?: number, reason?: string) => void;
  reconnectAttempt: number;
}

export const getReconnectDelay = (
  attemptNumber: number,
  reconnectInterval: BaseWsOptions['reconnectInterval']
): number => {
  if (typeof reconnectInterval === 'function') {
    return reconnectInterval(attemptNumber);
  }

  if (typeof reconnectInterval === 'number') {
    return reconnectInterval;
  }

  return PRICE_WS_RECONNECT_INTERVAL_MS;
};
